import { ComplianceItemView } from './types/complianceTypes';

export function createDefaultComplianceItem(createdBy: string = 'Unknown User'): ComplianceItemView {
  const currentDateTime = new Date().toISOString();

  return {
    id: '',

    // Facility
    center: '',
    centerName: '',
    facilityType: '',

    // Identification
    title: '',
    description: '',
    complianceType: '',
    accreditationBody: '',
    standard: '',
    requirement: '',
    category: '',

    // Schedule
    frequencyRequired: '',
    nextDueDate: undefined,
    lastCompletedDate: undefined,
    reminderDays: 30,

    // Tracking
    completedBy: '',
    completedDate: undefined,
    isVendorPerformed: false,
    vendorName: '',
    verifiedBy: '',
    verifiedDate: undefined,

    // Status / Notes
    status: 'NOTSTARTED',
    notes: '',

    // Audit
    createdBy: createdBy,
    createdDate: currentDateTime,
    lastModifiedDate: currentDateTime,
    lastModifiedBy: createdBy,

    documentCount: 0,
  };
}
